export function getRightDeclensionForOfferType(offerTypeText: string): string {
  if (offerTypeText.toLowerCase().startsWith('многокомнатная')) {
    return 'многокомнатную квартиру';
  }

  if (offerTypeText.toLowerCase().endsWith('квартира')) {
    return offerTypeText.replace('квартира', 'квартиру');
  }

  switch (offerTypeText.toLowerCase()) {
    case 'доля':
      return 'долю';

    case 'комната':
      return 'комнату';

    case 'квартира свободной планировки':
      return 'квартиру свободной планировки';

    case 'студия':
      return 'студию';

    case 'апартаменты-студия':
      return 'апартаменты-студию';

    default:
      return offerTypeText;
  }
}
